import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { connect } from 'react-redux';
import { getStripeConfig } from '../index';

const mapStateToProps = ({ stripeWidget }) => ({ stripeWidget });

const StripeScriptWrapper = ({ children, stripeWidget, id }) => {
  const { publishableKey } = getStripeConfig({ stripeWidget, id });
  const [stripePromise, setStripePromise] = useState();
  useEffect(() => {
    if (!publishableKey) return;
    setStripePromise(loadStripe(publishableKey));
  }, [publishableKey]);
  if (!stripePromise || !publishableKey) return null;
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

StripeScriptWrapper.defaultProps = {
  stripeWidget: [],
};

StripeScriptWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  stripeWidget: PropTypes.arrayOf(
    PropTypes.shape({
      paymentIntentSecret: PropTypes.string.isRequired,
      publishableKey: PropTypes.string.isRequired,
      completedPayment: PropTypes.bool.isRequired,
      serviceFee: PropTypes.number.isRequired,
      errorMessage: PropTypes.string.isRequired,
    }),
  ),
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(StripeScriptWrapper);
